import { render, staticRenderFns } from "./AboutIntroSection.vue?vue&type=template&id=26a20852&scoped=true&"
import script from "./AboutIntroSection.vue?vue&type=script&lang=js&"
export * from "./AboutIntroSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutIntroSection.vue?vue&type=style&index=0&id=26a20852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a20852",
  null
  
)

export default component.exports